export const DEALER_COUNTRIES = [
  { code: "NL", name: "Nederland" },
  { code: "BE", name: "België" },
  { code: "DE", name: "Duitsland" },
  { code: "FR", name: "Frankrijk" },
  { code: "UK", name: "Verenigd Koninkrijk" },
  { code: "IT", name: "Italië" },
  { code: "CH", name: "Zwitserland" },
  { code: "AT", name: "Oostenrijk" },
  { code: "DK", name: "Denemarken" },
  { code: "NO", name: "Noorwegen" },
  { code: "LI", name: "Liechtenstein" },
];
